import { client } from "../net/client";
import { useSignal } from "../net/signal";

/**
 * حساب در صفحه‌ی بازی — فقط «وارد شده‌ای یا نه».
 *
 * فرمِ ثبت‌نام/ورود صفحه‌ی جداگانه‌ی سایت است (`/account.html` از
 * `site/build.ts` + `site/auth.js`)، نه این‌جا: بازی سبک می‌مانَد و متن و توضیحِ حساب جایش در صفحه‌ی معرفی است.
 * این‌جا فقط می‌پرسیم ثبت‌شده است، و اگر نه، می‌فرستیمش آن‌جا و برمی‌گردانیم.
 *
 * چرا ثبت‌نام برای بازی لازم است: حساب به شناسه‌ی این مرورگر بسته است و
 * پاک‌کردنِ دادهٔ سایت یا عوض‌کردنِ دستگاه یعنی سکه و انبار رفته. تماشا آزاد
 * است؛ نشستن سرِ میز نه.
 */

export type AuthMode = "register" | "login" | "password";

/** حسابِ فعال؟ = ثبت‌شده و ایمیلش تأییدشده. نامِ خالی یعنی مهمان؛ نامِ پُر و
    verified نادرست یعنی هنوز کدِ ایمیل را نزده. */
export function useRegistered(): boolean {
  const username = useSignal(client.username);
  const verified = useSignal(client.verified);
  return username !== "" && verified;
}

/**
 * نشانیِ صفحه‌ی حساب (`/account.html`، ساخته‌ی site/build.ts) با برگشت به همین‌جا.
 *
 * `next` مسیرِ فعلی با query است تا لینکِ اتاقِ دوست (`?room=`) از دست نرود:
 * بعدِ ثبت‌نام همان‌جا برمی‌گردد و می‌پیوندد.
 */
export function authHref(mode: AuthMode): string {
  const next = typeof location !== "undefined" ? location.pathname + location.search : "/play";
  return "/account.html?auth=" + mode + "&next=" + encodeURIComponent(next);
}

/**
 * دروازه‌ی لابی: جای دکمه‌های بازی، تا ثبت‌نام نکرده‌ای.
 *
 * پیام می‌گوید **چرا** — نه فقط «ثبت‌نام کن». بازیکنی که نمی‌داند سکه‌اش با
 * پاک‌شدنِ مرورگر می‌رود، ثبت‌نام را مزاحمت می‌بیند، نه محافظت.
 */
export function AuthGate() {
  const username = useSignal(client.username);
  if (username) {
    // ثبت‌شده ولی تأییدنشده: فقط یک کار مانده.
    return (
      <div className="plate stack gate">
        <b>ایمیلت را تأیید کن</b>
        <div className="muted">کدِ ۶رقمی به ایمیلت رفته. تا تأیید نشود، حساب فعال نیست و سرِ میز نمی‌نشینی.</div>
        <a className="btn" href={authHref("login")}>زدنِ کد</a>
      </div>
    );
  }
  return (
    <div className="plate stack gate">
      <b>برای نشستن سرِ میز ثبت‌نام کن</b>
      <div className="muted">
        سکه، قهرمان‌ها و فرش‌هایت روی سرور می‌مانند و با نام و رمز روی هر دستگاهی برمی‌گردند.
        شماره و ایمیل نمی‌خواهیم؛ یک نام و یک رمز.
      </div>
      <div className="row" style={{ gap: 8 }}>
        <a className="btn" style={{ flex: 1 }} href={authHref("register")}>ثبت‌نام</a>
        <a className="btn ghost" style={{ flex: 1 }} href={authHref("login")}>حساب دارم — ورود</a>
      </div>
    </div>
  );
}
